import React, { useState } from "react";
import { Modal, Flex, Text, Button } from "@jsq/ds/core";
import { DeleteProfileModalProps } from "./types";

export const DeleteProfileModal: React.FC<DeleteProfileModalProps> = ({
  profile,
  caseId,
  show,
  rootProfileName,
  onClose,
  onDelete,
}) => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleDelete = async () => {
    if (!profile) return;
    try {
      setIsSubmitting(true);
      await onDelete(caseId, profile.id);
      onClose();
    } finally {
      setIsSubmitting(false);
    }
  };

  const listDescendants = () => {
    if (!profile) return null;
    return (
      <Text asSpan variant="regular-md">
        <ul>
          {profile.descendantNames.map((name, index) => (
            <li key={index}>{name}</li>
          ))}
        </ul>
      </Text>
    );
  };

  return (
    <Modal show={show} size="medium">
      <Modal.Header closeButton onHide={onClose}>
        <Modal.Title>Warning</Modal.Title>
      </Modal.Header>
      <Flex flexDirection="column" gap="16px">
        <Text marginBottom="md">
          {!profile ? (
            "Error: Profile information not available"
          ) : profile.isOrHasPaymentBeneficiary ? (
            `Cannot delete ${profile.name} because the profile or one or more of its owners and/or controllers is a payment beneficiary.`
          ) : profile.descendantNames.length > 0 ? (
            <>
              <Text marginBottom="md">
                {rootProfileName
                  ? `Removing ${profile.name} will also remove profiles of any owners and controllers of ${profile.name} and its subsidiaries:`
                  : `Deleting ${profile.name} will also delete its owners and controllers:`}
              </Text>
              {listDescendants()}
            </>
          ) : rootProfileName ? (
            `Are you sure you want to remove ${profile.name} from the ${rootProfileName} organization structure?`
          ) : (
            `Are you sure you want to delete ${profile.name}?`
          )}
        </Text>
      </Flex>
      <Flex flexDirection="row" gap="10px" justifyContent="flex-end">
        <Button onClick={onClose} variant="neutral">
          Cancel
        </Button>
        <Button
          isLoading={isSubmitting}
          onClick={() => void handleDelete()}
          variant="danger"
          disabled={!profile || !!profile.isOrHasPaymentBeneficiary}
        >
          Delete
        </Button>
      </Flex>
    </Modal>
  );
};
